import {replaceWindowPositions, replaceInletIds} from 'utils/replaceInletIds.js';
import {inletToggled, inletCreated} from './subpatch/operations.js';
import {
    setInletConnections} from 'actions/index.js';

export default superclass => class extends superclass {

    // list of all instances that have been made from this subpatch
    // these instances share the standard inlets. messages to these shared
    // inlets get propagated to the instances
    instances = [];

    // instance inlets get shown in any "instances" of this subpatch
    // that get created
    // while other inlets are hidden, and "shared" by all the instances
    instanceInlets = [];

    newInstance() {
        let instance = this.subSequence.createZObject(
            this.x, this.y, "instancedSubpatch").effect;

        instance.implements = this;

        this.instances.push(instance);

        this.copyIntoInstance(instance);
        this.onChange();
    }

    toggleInlet(inlet) {
        if (this.instanceInlets.includes(inlet)) {
            // its an instance inlet so turn into shraed
            this.instanceInlets = this.instanceInlets.filteR(
                x => x !== inlet);
        } else {
            this.instanceInlets.push(inlet);
        }
        this.propagate(inletToggled(inlet.inletNumber));
    }

    newInstanceInlet(number=this.inletObjects.length+1, id, x, y) {
        let zMessage = this.newInlet(number, id, x, y, false);
        this.instanceInlets.push(zMessage);

        this.propagate(
            inletCreated(zMessage, true));
        return zMessage;
    }

    onInletMessage(object, msg) {
        if (this.hasInstances && !this.instanceInlets.includes(object)) {
            // then we need to propagate to all the instances
            for (let instance of this.instances) {
                let indexOf = this.inletObjects.indexOf(object);
                let _object = instance.inletObjects[indexOf];
                if (_object) {
                    _object.sendMessage("Output", ...msg);
                }
            }
        } else {
            object.sendMessage("Output", ...msg);
        }
    }

    get hasInstances() {
        return this.instances.length > 0;
    }

    insideInstance() {
        if (this.hasInstances) {
            return true;
        }

        let subpatch = this.subSequence;

        return subpatch.insideInstance();
    }

    /**
     * 
     * Not used anymore (DELETE)
     */
    onChange(force=false) {
        return;
    }

    copyIntoInstance(instance) {
        for (let zobject of this.zObjects) {
            if (zobject.name === "subpatch") {
                let subpatch = zobject.effect;
                subpatch.showAllOutlets = true;
                let _zobject = instance.createZObject(0,0,"instancedSubpatch");
                instance.registerObject(zobject, _zobject);
                subpatch.instances.push(_zobject.effect);
                subpatch.copyIntoInstance(_zobject.effect);

                if (zobject.effect) {
                    instance.registerObject(zobject.effect, _zobject.effect);
                }
            } else {
                let _zobject = instance.createZObject(0,0,zobject.text);
                _zobject.fromJson(zobject.getJson(), true);
                instance.registerObject(zobject, _zobject);
                if (zobject.effect) {
                    instance.registerObject(zobject.effect, _zobject.effect);
                }
            }
        }

        for (let zmessage of this.zMessages) {
            if (zmessage.isInlet) {
                let {inletNumber} = zmessage;
                let instanceInlet = instance.inletObjects.find(x => x.inletNumber === inletNumber);
                let inlet;
                if (instanceInlet) {
                    inlet = instanceInlet;
                    instance.registerObject(zmessage, instanceInlet);
                } else {
                    if (this.instanceInlets.includes(zmessage)) {
                        inlet = instance.newInstanceInlet();
                        instance.registerObject(zmessage, inlet);
                    } else {
                        inlet = instance.newInlet();
                        inlet._text = zmessage._text;
                        instance.registerObject(zmessage, inlet);
                    }
                }
                inlet._text = zmessage._text;
                continue;
            }
            if (zmessage.isOutlet) {
                let {outletNumber} = zmessage;
                let instanceOutlet = instance.outletObjects.find(x => x.outletNumber === outletNumber);
                if (instanceOutlet) {
                    instanceOutlet._text = zmessage._text;
                    instance.registerObject(zmessage, instanceOutlet);
                } else {
                    let outlet = instance.newOutlet();
                    outlet._text = zmessage._text;
                    instance.registerObject(zmessage, outlet);
                }
                continue;
            }
            let _zmessage  = instance.createZMessage(0,0,zmessage.dataType);
            _zmessage.fromJson(zmessage.getJson(), true);
            instance.registerObject(zmessage, _zmessage);
        }

        this.copyConnectionsIntoInstance(instance);
    }

    copyConnectionsIntoInstance(instance) {
        let {inletConnections} = this.zObject.getPresetJson();

        let idToId = {};
        for (let id in instance.objectRegistry) {
            idToId[id] = instance.objectRegistry[id].id;
        }

        inletConnections = replaceInletIds(
            idToId, inletConnections);

        let bulk = this.sequencerEngine.loadInletConnectionsForId(
            inletConnections, true);
        // we actually dont care about the redux for these things
        return;
        let subSequence = this.getRootSubSequence();
        let connections = this.state.windows.inletConnections[subSequence.id] || {};
        this.dispatch(
            setInletConnections(
                subSequence.id,
                {
                    ... connections,
                    ... bulk
                }));
    }
}
